module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_9.39c16091.png";